import React, { useState } from "react";
import {
	Typography,
	styled,
	Stack,
	Button,
	Box,
} from "@mui/material";
import { useSelector } from "react-redux";
import CustomTextField from "../components/FormInputField";
import { inviteByEmail } from "../../../services/clients/ContactsService";
import { showToast } from "../../../components/ui/toaster";

const StyledTypography = styled(Typography)({
	fontSize: "14px",
	color: "#404585",
	fontWeight: "600",
	fontFamily: 'Figtree-Regular'
});

const StyledButton = styled(Button)({
	backgroundColor: "#638DFF",
	textTransform: 'unset',
	fontSize: '13px !important',
	fontWeight: '600',
	padding: '0px',
	borderRadius: '10px' ,
	fontFamily: 'Figtree-Regular',
	height: "40px",
	"&:hover": {
		backgroundColor: "#114ef5",
	},
});

const EmailInviteFunctional = () => {
    const selectedDomain = useSelector((state) => state.domain.selectedDomain);
	const [email, setEmail] = useState("");
	const [showEmailError, setShowEmailError] = useState(false);

	const changeEmail = (e) => {
		setEmail(e?.target?.value);
	};

	const sendEmailInvite = (emails) => {
		inviteByEmail(emails, selectedDomain)
			.then(() => {
				showToast('success', "Invite sent successfully.");
                setEmail('');
			})
			.catch((error) => {
				console.log("error ", error);
				showToast('error', "Error while sending the invite. Please try again later.");
			});
	};

	const sendInvite = () => {
		let emails = [];
		let check = checkEmail(email);
		setShowEmailError(false);
		if (!check) {
			setShowEmailError(true);
		} else {
			emails.push(email);
			sendEmailInvite(emails);
		}
	};

	const checkEmail = (str) => {
		var regex =
			/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if (!regex.test(str)) {
			return false;
		}
		return true;
	};

	return (
		<Stack spacing={2}>
			<StyledTypography>Send an email invitation to a friend</StyledTypography>
			<Box sx={{ mt: "1rem" }}>
				<CustomTextField
					label="Email"
					type="email"
					value={email}
					error={showEmailError}
					placeholderValue={'email@example.com'}
					handleInputChange={(e) => changeEmail(e)}
					/>
			</Box>
			{showEmailError && (
				<Box sx={{ color: "#FE3A3A", mt: "-6px !important", fontSize:"12px" }}>
					Invalid email address. Please try again
				</Box>
			)}
			<StyledButton variant="contained" fullWidth onClick={sendInvite}>
				Invite User
			</StyledButton>
		</Stack>
	);
};

export default EmailInviteFunctional;
